/* eslint-disable no-plusplus */
let instance = null;

class EventBus {
    constructor() {
        if (!instance) {
            this.listeners = {};
            instance = this;
        }

        return instance;
    }

    getListenerIdx(eventName, callback, scope) {
        const eventListeners = this.listeners[eventName];
        let i;
        let idx = -1;

        if (!eventListeners || eventListeners.length === 0) {
            return idx;
        }

        for (i = 0; i < eventListeners.length; i++) {
            if (
                eventListeners[i].callback === callback
                && (!scope || scope === eventListeners[i].scope)
            ) {
                idx = i;
                break;
            }
        }

        return idx;
    }

    subscribe(eventName, callback, scope) {
        if (!eventName) {
            throw new Error('Event name cannot be null or undefined');
        }

        if (!callback || typeof callback !== 'function') {
            throw new Error('Listener must be of type function.');
        }

        const idx = this.getListenerIdx(eventName, callback, scope);

        if (idx >= 0) return;

        const listener = {
            callback,
            scope,
        };

        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(listener);
    }

    unsubscribe(eventName, callback, scope) {
        if (!eventName || !callback || !this.listeners[eventName]) {
            return;
        }

        const idx = this.getListenerIdx(eventName, callback, scope);

        if (idx === -1) return;

        this.listeners[eventName].splice(idx, 1);
    }

    broadcast(eventName, args = {}) {
        const eventListeners = this.listeners[eventName];

        if (!eventName || !this.listeners[eventName]) {
            return;
        }

        eventListeners.forEach((listener) => {
            listener.callback.call(listener.scope, args);
        });
    }

    reset() {
        this.listeners = {};
    }
}

export default new EventBus();
